import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SolicitudesComponent } from './componentes/solicitudes/solicitudes.component';
import { SolicitudesRoutingModule } from './solicitudes-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { PersonaComponent } from './componentes/persona/persona.component';
import { StoreModule } from '@ngrx/store';
// import { solicitudReducer } from './ngrx/solicitudes.reducer';
import { DireccionComponent } from './componentes/direccion/direccion.component';
import { DiscapacidadesComponent } from './componentes/discapacidades/discapacidades.component';
import { IngresosComponent } from './componentes/ingresos/ingresos.component';
import { SolicitanteComponent } from './componentes/solicitante/solicitante.component';
import { PadreComponent } from './componentes/padre/padre.component';
import { MadreComponent } from './componentes/madre/madre.component';
import { TutorComponent } from "./componentes/tutor/tutor.component";
import { AvalesComponent } from './componentes/avales/avales.component';
import { ReferenciasPersonalesComponent } from './componentes/referencias-personales/referencias-personales.component';
import { ReferenciasFamiliaresComponent } from './componentes/referencias-familiares/referencias-familiares.component';
import { PersonasViviendaComponent } from './componentes/personas-vivienda/personas-vivienda.component';
import { DatosEscolaresLaboralesComponent } from './componentes/datos-escolares-laborales/datos-escolares-laborales.component';
import { DatosUnicosComponent } from './componentes/datos-unicos/datos-unicos.component';
import { TelefonoComponent } from './componentes/telefono/telefono.component';
import { DireccionEmpresaComponent } from './componentes/direccion-empresa/direccion-empresa.component';
import { EscolaresLaboralesComponent } from './componentes/escolares-laborales/escolares-laborales.component';
import { ArchivosComponent } from './componentes/archivos/archivos.component';
import { ConfirmacionValidarComponent } from './componentes/confirmacion-validar/confirmacion-validar.component';
import { DocumentacionFormComponent } from './componentes/documentacion-form/documentacion-form.component';
import { DocumentosComponent } from './componentes/documentos/documentos.component';
import { ImageUploadModule } from "angular2-image-upload";

import { ContratoComponent } from './componentes/contrato/contrato.component';
import { ModalComponent } from './componentes/modal/modal.component';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../shared/material.module';

@NgModule({
	declarations: [
		SolicitudesComponent,
		PersonaComponent,
		DireccionComponent,
		DiscapacidadesComponent,
		IngresosComponent,
		SolicitanteComponent,
		PadreComponent,
		MadreComponent,
		TutorComponent,
		AvalesComponent,
		ReferenciasPersonalesComponent,
		ReferenciasFamiliaresComponent,
		PersonasViviendaComponent,
		DatosEscolaresLaboralesComponent,
		DatosUnicosComponent,
		TelefonoComponent,
		DireccionEmpresaComponent,
		EscolaresLaboralesComponent,
		ArchivosComponent,
		ConfirmacionValidarComponent,
		DocumentacionFormComponent,
		DocumentosComponent,
		ContratoComponent,
		ModalComponent,

	],
	imports: [
    MaterialModule,
		CommonModule,
		SolicitudesRoutingModule,
		SharedModule,
		FormsModule,
		ReactiveFormsModule,
		// StoreModule.forFeature("solicitud", solicitudReducer),
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyC3WkNnqvtrrFiuRAX6aMge0bDGhK_BFBk',
		}),
		ImageUploadModule.forRoot(),
	],
	bootstrap: [SolicitudesComponent]
})
export class SolicitudesModule { }
